import React, { Component } from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

const CAPTCHA_CHARS = 6;

class Captcha extends Component {
    componentDidMount() {
        loadCaptchaEnginge(CAPTCHA_CHARS, "white", "black", "lower");
    }

    onSubmit = () => {
        let user_captcha = document.getElementById("user_captcha_input").value;
        if (validateCaptcha(user_captcha)) {
            this.props.func();
        } else {
            alert("Captcha mismatch");
            document.getElementById('user_captcha_input').value = "";
        }
    }

    render() {
        return (
            <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 space-y-4">
                {/* Header */}
                <div className="text-center">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">Security Check</h3>
                    <p className="text-sm text-gray-600">Help us maintain a safe learning environment</p>
                </div>

                {/* Captcha Canvas */}
                <div className="flex justify-center">
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                        <LoadCanvasTemplateNoReload />
                    </div>
                </div>

                {/* Input Field */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2 text-center">
                        Type the characters you see above
                    </label>
                    <input
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200 text-center text-lg tracking-wider"
                        id="user_captcha_input"
                        type="text"
                        placeholder="Enter captcha"
                        autoComplete="off"
                    />
                </div>

                {/* Submit Button */}
                <div className="flex justify-center">
                    <button 
                        className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-md w-full max-w-xs"
                        onClick={() => this.onSubmit()}
                    >
                        Verify & Continue
                    </button>
                </div>

                {/* Friendly Explanation */}
                <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
                    <div className="flex items-start">
                        <svg className="w-5 h-5 text-blue-500 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                            <p className="text-sm text-blue-700 font-medium">Why we need this verification</p>
                            <p className="text-xs text-blue-600 mt-1">
                                We're not against robots per se, but we need to prevent automated systems from being used for malicious purposes that could disrupt the learning experience for everyone.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Captcha;